import { render, staticRenderFns } from "./NewUser.vue?vue&type=template&id=f8a0c8d0&scoped=true&"
import script from "./NewUser.vue?vue&type=script&charset=utf-8&lang=js&"
export * from "./NewUser.vue?vue&type=script&charset=utf-8&lang=js&"
import style0 from "./NewUser.vue?vue&type=style&index=0&id=f8a0c8d0&lang=scss&rel=stylesheet%2Fsass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a0c8d0",
  null
  
)

export default component.exports